import styled from 'styled-components'

export const Container = styled.main`
  display: flex;
  justify-content: center;
  padding: 62px 32px;
`

export const TermsContainer = styled.article`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 900px;
  text-align: center;
  width: 100%;

  p {
    text-align: justify;

    a {
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
    }

    @media (max-width: 500px) {
      font-size: 12px;
    }
  }

`
